/** @format */

const apiURL = process.env.REACT_APP_API_URL;

export async function updateStatusDocuments(
    currentstatus,
    newstatus,
    docList,
    token
  ) {
  
    const apiUrl = `${apiURL}/admin/document/massupdate`;
  
    const parsedDocList = JSON.parse(docList);
  
    const fetchbody = JSON.stringify({
      "CurrentStatus": currentstatus,
      "NewStatus": newstatus,
      "DocList" : parsedDocList
    });
  
    try {
      const response = await fetch(apiUrl, {
        method: "PATCH",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        body: fetchbody
      });
  
      const data = await response.json();
      if (!response.ok) {
        console.error('Error response from server:', data);
        throw new Error('Erreur lors de la mise à jour des documents');
      }
      return data;
  
    } catch (error) {
      console.error("Error fetching documents:", error);
      throw error;
    }
  }
  